__turbopack_context__.v({
  "hero-section": "profile-dashboard-hero-section-module-scss-module__B7w4iW__hero-section",
  "hero-section__badge-container": "profile-dashboard-hero-section-module-scss-module__B7w4iW__hero-section__badge-container",
  "hero-section__summary-container": "profile-dashboard-hero-section-module-scss-module__B7w4iW__hero-section__summary-container",
});
